import { Component, Injector, OnInit } from '@angular/core';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { OrganizationPractitionerDetailsComponent } from './details/practitioner-details.component';
import { OrganizationPractitionerLinkComponent } from './bond/practioner-registration.component';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { CreatePractitionerComponent } from '../../components/create-practitioner/create-practitioner.component';

@Component({
  selector: 'page-organization-practitioner',
  templateUrl: './practioner.component.html',
  styleUrls: ['./practioner.component.scss'],
})
export class OrganizationPractitionerComponent extends BaseComponent implements OnInit {
  public practitioners: any[] = [];
  public practitionersAffiliation: any[] = [];
  public affiliations: any[] = [];
  private practitionerRole: any[] = [];
  public title = 'Especialistas';
  public practitionerActive: any[] = [];
  public practitionerInactive: any[] = [];
  public practitionerPending: any[] = [];

  constructor(
    private injector: Injector,
    private affiliationService: PractitionerOrganizationAffiliationService,
    private practitionerService: PractitionerService
  ) {
    super(injector);
    this.currentUser = this.auth.currentUserValue;
  }

  async ngOnInit() {
    try {
      const [affiliations] = await Promise.all([this.getAffiliations()]);
      this.affiliations = this.transformFhirToModel(affiliations || []);
      this.practitionersAffiliation = this.affiliations;
      this.categorizePractitioners();
    } catch (error) {
      console.error('Error loading data:', error);
    }
  }

  async getPractitioners(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.practitionerService.list().subscribe({
        next: (resPractitioner: any) => resolve(resPractitioner || []),
        error: (err) => {
          console.error('Falha ao buscar especialistas:', err);
          reject(err);
        },
      });
    });
  }

  getPractitionerPhoto(practitioner_id: string): string {
    const practitioner = this.practitionersAffiliation.find((prac) => prac.practitioner_id === practitioner_id);
    const url = practitioner && practitioner.practitioner_photo ? practitioner.practitioner_photo : this.defaultPractitionerPhoto;
    return url;
  }

  async getAffiliations(): Promise<any[]> {
    const organizationId = this.currentUser.user.id;

    return new Promise((resolve, reject) => {
      this.affiliationService.show(organizationId).subscribe({
        next: (resAffiliation: any) => resolve(resAffiliation || []),
        error: (err) => {
          console.error('Erro ao buscar vinculações:', err);
          reject(err);
        },
      });
    });
  }

  getPractionersAffiliations() {
    const practitionerIdsAffiliation = new Set(this.affiliations.map((obj) => obj.practitioner_id));

    return this.practitioners
      .filter((practitioner) => practitionerIdsAffiliation.has(practitioner.practitioner_id))
      .map((practitioner) => ({
        ...this.affiliations.find((affiliation) => affiliation.practitioner_id === practitioner.practitioner_id),
        ...practitioner,
      }));
  }

  categorizePractitioners() {
    this.practitionerActive = this.practitionersAffiliation.filter((affiliation) =>
      affiliation.specialty.some((specialty: any) => specialty.status === 'accepted')
      || affiliation.status === 'accepted'
    );
    this.practitionerInactive = this.practitionersAffiliation.filter((affiliation) =>
      affiliation.specialty.some((specialty: any) => specialty.status === 'cancelled') 
      || affiliation.status === 'cancelled'
    );
    this.practitionerPending = this.practitionersAffiliation.filter((affiliation) =>
      affiliation.specialty.some((specialty: any) => specialty.status === 'requested')
     || affiliation.status === 'requested'
    );
  }

  transformFhirToModel(jsonData: any[]) {
    return jsonData.map((item) => ({
      affiliation_id: item.affiliation_id,
      organization_name: item.subject.display,
      organization_id: item.subject.id,
      organization_photo: item.subject.photo,
      organization_address: item.address,
      practitioner_name: item.request.display,
      practitioner_photo: item.request.photo,
      practitioner_id: item.request.id,
      practitioner_details: item.request.details,
      changeRequest: item.changeRequest,
      specialty: item.specialty,
      practitionerHours: item.practitionerHours,
      requestDateTime: item.requestDateTime,
      updateDateTime: item.updateDateTime,
      status: item.status
    }));
  }

  refreshAffiliations() {
    this.getAffiliations().then((affiliations) => {
      this.affiliations = this.transformFhirToModel(affiliations);
      this.practitionersAffiliation = this.affiliations;
      this.categorizePractitioners();
    });
  }

  getCity(practioner: any) {
    return practioner?.address?.[0]?.city || practioner?.practitioner_details?.address?.[0]?.city || 'Localização não informada';
  }

  getAddress(practitioner: any) {
    if (!practitioner.address) return 'Localização não informada';
    const city = practitioner.address?.[0]?.city;
    const state = practitioner.address?.[0]?.state;
    return city && state ? `${city}/${state}` : 'Localização não informada';
  }

  getPrefix(practitioner: practitionerI) {
    if (practitioner.gender) {
      return practitioner.gender === 'Female' ? 'Dra. ' : 'Dr. ';
    }
    return '';
  }

  openPractitionerRegistration() {
    
    this.dialog.openComponentDialog(CreatePractitionerComponent).subscribe({
      next: () => {
        this.refreshAffiliations()
        this.router.navigate([])
      }
        
        
    });;
  }

  openPractitionerDetailForm(practitioner: any, type?: string) {
    const data = {
      title: practitioner.practitioner_name || practitioner.name || 'Detalhes do Especialista',
      param: {
        practioner: practitioner,
        affiliation: this.affiliations.find((affiliation) => affiliation.practitioner_id === practitioner.practitioner_id),
        type,
      },
    };

    this.dialog.openComponentDialog(OrganizationPractitionerDetailsComponent, data).subscribe({
      next: () => this.refreshAffiliations(),
    });
  }
}
